// Meta-data
export const META_GET_ALL = 'OrganizationService/api/meta-data/get-all';
export const META_UPDATE = 'OrganizationService/api/meta-data/update';

// Work Schedule
export const GET_ALL_WORK_SCHEDULES = 'TimeManagementService/api/Work-Schedule/get-all';
export const SEARCH_WORK_SCHEDULES = 'TimeManagementService/api/Work-Schedule/search';
export const GET_WORK_SCHEDULE_BY_ID = 'TimeManagementService/api/Work-Schedule/get'; // append /{id} dynamically
export const CREATE_WORK_SCHEDULE = 'TimeManagementService/api/Work-Schedule/create';
export const UPDATE_WORK_SCHEDULE = 'TimeManagementService/api/Work-Schedule/update'; // append /{id} dynamically
export const DELETE_WORK_SCHEDULE = 'TimeManagementService/api/Work-Schedule/delete'; // append /{id} dynamically
export const BULK_DELETE_WORK_SCHEDULE = 'TimeManagementService/api/Work-Schedule/bulk-delete';

export const GET_WORK_SCHEDULE_BASIC_DETAILS =
  'TimeManagementService/api/Work-Schedule/get-basic-details';

// TimeManagementLookup
export const GET_ALL_DROPDOWN_WORK_SCHEDULE = 'TimeManagementService/api/Time-Management-Lookup/get-all-drop-down';